<div class="multi-select-container" [class.disabled]="disabled">
 
  <!-- Trigger row -->
  <div class="trigger" [class.edit-mode]="editMode()" [class.open]="isOpen" (click)="toggleDropdown()">
    <span class="item-selected">
      @if (selectedItems().length > 0) {
        {{ displayLabel() }}
      } @else {
        <span class="placeholder">{{ placeholder() }}</span>
      }
    </span>
    @if (editMode()) {<span class="arrow" [class.open]="isOpen"></span>}
  </div>
 
  <!-- Dropdown panel -->
  @if (isOpen) {
    <div class="dropdown">
      @for (item of options(); track item['id']) {
        <div
          class="option"
          [class.selected]="isSelected(item)"
          (click)="toggleItem(item)"
        >
          <span class="option-check">{{ isSelected(item) ? '✓' : '' }}</span>
          <span class="item-name">{{ item[displayPath()] }}</span>
        </div>
      }
      @if (options().length === 0) {
        <div class="option no-options">
          <span class="item-name">No options available</span>
        </div>
      }
    </div>
  }
 
</div>